import { useCallback, useState, type FocusEvent, type MouseEvent } from 'react';
import { Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import PaymentOption from '~/components/PurchasePaymentMethod/PaymentOption';
import { CS_PHONE_NUMBER } from '~/constants';

type PayWithCashOptionProps = {
  checked: boolean;
  onSelect: () => void;
};

export default function PayWithCashOption({
  checked,
  onSelect,
}: PayWithCashOptionProps) {
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;
  const [copied, setCopied] = useState<boolean>(false);

  const handleCopy = () => {
    navigator.clipboard
      .writeText(CS_PHONE_NUMBER)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 5000);
      })
      .catch((err) => {
        console.error('Failed to copy text: ', err);
      });
  };

  const stopPropagation = useCallback(
    (event: MouseEvent<HTMLDivElement> | FocusEvent<HTMLDivElement>) => {
      event.stopPropagation();
    },
    [],
  );

  return (
    <div className="border border-gray rounded-[8px] p-3x w-full">
      <PaymentOption
        checked={checked}
        onClick={onSelect}
        radioName="selectedPayment"
        title={<p className="text-link md:text-title_4">{t('cashPayment')}</p>}
        rightContent={
          <Icon name="money" size="24px" className="text-gray__dark_2" />
        }
      />

      <div
        className={` p-0 ${checked ? '  border-t border-t-gray pt-3x mt-3x' : ''}`}
        onClick={stopPropagation}
        onFocus={stopPropagation}
      >
        {checked && (
          <div className="flex gap-x items-start md:items-center flex-col md:flex-row w-full ">
            <p className="text-body-2 md:text-body_1 text-gray__dark_2 whitespace-nowrap">
              {t('cashSubscriptionDescription')}
            </p>
            <div className="flex gap-x  items-center w-full justify-between md:justify-start">
              <span
                className="text-body-2 md:text-body_1 text-black "
                dir="ltr"
              >
                {CS_PHONE_NUMBER}
              </span>

              <a
                href={`tel:${CS_PHONE_NUMBER}`}
                className="flex  items-end justify-end md:items-center md:justify-between rounded-full md:hidden "
              >
                <Icon
                  name="phone"
                  className={[
                    'text-blue',
                    locale === 'ar' ? 'rotate-90' : '',
                  ].join(' ')}
                  size="32px"
                />
              </a>
              <button className="hidden md:block" onClick={handleCopy}>
                {copied ? (
                  <Icon name="check" className="text-green_dark" size="24px" />
                ) : (
                  <Icon name="copy" className="text-blue" size="24px" />
                )}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
